import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsAltH } from "@fortawesome/pro-regular-svg-icons";

export const defaultTranslations = {
  pluginName: "Product Slider",
  pluginDescription: "Add product slider",
};

export const defaultSettings = {
  Controls: () => <>Controls for this plugin were not provided</>,
  Renderer: () => <>Renderer for this plugin was not provided</>,
  translations: defaultTranslations,
  IconComponent: <FontAwesomeIcon icon={faArrowsAltH} size="3x" />,
};
